import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
// import NRIDetails from './NRIDetails/NRIDetails';
// Components
import ARCCustomer from '../../Containers/ARC_Upload/sales/BussinessCustomerMang/BussinessCustomerMang';
import ARCInvoiceManagement from '../../Containers/ARC_Upload/sales/InvoiceManagement/InvoiceManagement';
import ARCCollections from '../../Containers/ARC_Upload/sales/Collections/Collections';
import ARCPaymentAdvice from '../../Containers/ARC_Upload/sales/PaymentAdvice/PaymentAdvice';
import VenderManagement from '../../Containers/ARC_Upload/Purchase/VendorManagement/VenderManagement';
import PurchaseInvoiceMgmt from '../../Containers/ARC_Upload/Purchase/BillManagement/PurchaseMgmt';
import VendorCollections from '../../Containers/ARC_Upload/Purchase/Collections/Collections';
import VendorpaymentAdvice from '../../Containers/ARC_Upload/Purchase/VendorPaymentsAdvice/VendorpaymentAdvice';
import COAManagement from './COA/coa';
import DaybookManagement from './Daybook/daybook';
import EmployeeDetails from './EmployeeDetails/Employeedetails';
import TDSTransactionDetails from './TDSTransactionDetails/TDSTransactiondetails';

export default function DataUploadCards() {
    const history = useHistory();
    const location = useLocation();

    // Read permissions from localStorage
    const arcUploadSale = localStorage.getItem("arcUploadSale") === "true";
    const arcUploadPurchase = localStorage.getItem("arcUploadPurchase") === "true";
    const daybook = localStorage.getItem("daybook") === "true";
    const coa = localStorage.getItem("coa") === "true";
    const employeeDetails = localStorage.getItem("employee_details") === "true";
    const tdsTransactionDetails = localStorage.getItem("tds_transaction_details") === "true";
    // const nriDetails = localStorage.getItem("nri_details") === "true";

    const salesTabs = arcUploadSale ? [
        { label: 'Customer', path: '/BusinessCustomerManagement', component: ARCCustomer },
        { label: 'Invoice Management', path: '/InvoiceManagement', component: ARCInvoiceManagement },
        { label: 'Collections', path: '/uploadCollectionsData', component: ARCCollections },
        { label: 'Payment Advice', path: '/uploadPaymentAdviceData', component: ARCPaymentAdvice },
    ] : [];

    const purchaseTabs = arcUploadPurchase ? [
        { label: 'Vendor', path: '/vendorManagement', component: VenderManagement },
        { label: 'Bill Management', path: '/PurchaseInvoiceMgmt', component: PurchaseInvoiceMgmt },
        { label: 'Vendor Payment', path: '/vendorCollections', component: VendorCollections },
        { label: 'Payment Advice', path: '/VendorpaymentAdvice', component: VendorpaymentAdvice },
    ] : [];

    const othersTabs = [
        ...(daybook ? [{ label: 'Day Book', path: '/daybook', component: DaybookManagement }] : []),
        ...(coa ? [{ label: 'Chart of Accounts', path: '/coa', component: COAManagement }] : []),
        ...(employeeDetails ? [{ label: 'Employee Details', path: '/employeeDetails', component: EmployeeDetails }] : []),
        ...(tdsTransactionDetails ? [{ label: 'TDS Transaction Details', path: '/tdsTransactionDetails', component: TDSTransactionDetails }] : []),
        //  ...(nriDetails ? [{ label: 'NRI Details', path: '/nriDetails', component: NRIDetails }] : []),  
    ];

    const hasOthersAccess = daybook || coa || employeeDetails || tdsTransactionDetails;

    const handleCardClick = (tab) => {
        history.push(tab.path);
    };

    const cardStyle = {
        background: '#ffffff',
        borderRadius: '12px',
        p: 3,
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        minHeight: '80px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderLeft: '5px solid #03406d',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: 0,
            height: '100%',
            width: '5px',
            background: '#03406d',
            transition: 'width 0.4s ease',
            zIndex: 0,
        },
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 4px 16px rgba(3, 64, 109, 0.25)',
            '& > div': {
                color: '#ffffff',
            },
        },
        '&:hover::before': {
            width: '100%',
        },
    };

    const cardLabelStyle = {
        fontSize: '16px',
        fontWeight: 600,
        color: '#212121',
        textAlign: 'center',
        position: 'relative',
        zIndex: 1,
        transition: 'color 0.3s ease',
    };

    const moduleBoxStyle = {
        flex: 1,
        background: 'linear-gradient(to bottom, #e3f2fd 0%, #f0f4ff 100%)',
        borderRadius: '16px',
        overflow: 'hidden',
        border: '3px solid #03406d',
        boxShadow: '0 4px 20px rgba(3, 64, 109, 0.15)',
    };

    const moduleHeaderStyle = {
        background: '#03406d',
        p: 2,
        mb: 2,
    };

    const moduleHeaderTextStyle = {
        fontSize: '28px',
        fontWeight: 700,
        color: '#ffffff',
        textAlign: 'center',
        letterSpacing: '1px',
    };

    const renderCards = (tabs, columns = 2) => (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: `repeat(${columns}, 1fr)`,
                gap: 2.5,
            }}
        >
            {tabs.map((tab, index) => (
                <Box key={index} onClick={() => handleCardClick(tab)} sx={cardStyle}>
                    <Box sx={cardLabelStyle}>{tab.label}</Box>
                </Box>
            ))}
        </Box>
    );

    const hasMultipleModules =
        (salesTabs.length > 0 ? 1 : 0) +
        (purchaseTabs.length > 0 ? 1 : 0) +
        (hasOthersAccess && othersTabs.length > 0 ? 1 : 0) > 1;

    // if (ActiveComponent) {
    //     return <ActiveComponent />;
    // }

    const noAccess = salesTabs.length === 0 && purchaseTabs.length === 0 && othersTabs.length === 0;

    return (
        <Box
            sx={{
                fontFamily: "'Inter', sans-serif",
                width: '100%',
                minHeight: '100vh',
                background: 'linear-gradient(to bottom, #e8eef5 0%, #f5f7fa 100%)',
                p: 0,
            }}
        >
            {/* Page Heading */}
            <Box sx={{ textAlign: 'center', pt: 3, pb: 0.5 }}>
                <Box
                    sx={{
                        fontSize: '38px',
                        fontWeight: 900,
                        color: '#03406d',
                        letterSpacing: '2px',
                        fontFamily: '"Dosis", sans-serif',
                        textTransform: 'uppercase',
                    }}
                >
                    UPLOADS
                </Box>
            </Box>

            {noAccess ? (
                <Box
                    sx={{
                        textAlign: 'center',
                        mt: 10,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <InfoOutlinedIcon sx={{ fontSize: 64, color: '#90a4ae', mb: 2 }} />
                    <Box sx={{ fontSize: '18px', color: '#607d8b' }}>
                        Please activate the Upload Services to access.
                    </Box>
                </Box>
            ) : hasMultipleModules ? (
                <Box sx={{ display: 'flex', gap: 3, p: 4, width: '100%', flexWrap: 'wrap' }}>
                    {/* SALES MODULE */}
                    {salesTabs.length > 0 && (
                        <Box sx={moduleBoxStyle}>
                            <Box sx={moduleHeaderStyle}>
                                <Box sx={moduleHeaderTextStyle}>SALES MODULE</Box>
                            </Box>
                            <Box sx={{ p: 4, pt: 0 }}>
                                {renderCards(salesTabs, 2)}
                            </Box>
                        </Box>
                    )}

                    {/* PURCHASES MODULE */}
                    {purchaseTabs.length > 0 && (
                        <Box sx={moduleBoxStyle}>
                            <Box sx={moduleHeaderStyle}>
                                <Box sx={moduleHeaderTextStyle}>PURCHASE MODULE</Box>
                            </Box>
                            <Box sx={{ p: 4, pt: 0 }}>
                                {renderCards(purchaseTabs, 2)}
                            </Box>
                        </Box>
                    )}

                    {/* OTHERS MODULE */}
                    {hasOthersAccess && othersTabs.length > 0 && (
                        <Box sx={moduleBoxStyle}>
                            <Box sx={moduleHeaderStyle}>
                                <Box sx={moduleHeaderTextStyle}>OTHERS MODULE</Box>
                            </Box>
                            <Box sx={{ p: 4, pt: 0 }}>
                                {renderCards(othersTabs, 2)}
                            </Box>
                        </Box>
                    )}
                </Box>
            ) : (
                <Box sx={{ p: 4, display: 'flex', justifyContent: 'center' }}>
                    <Box sx={{ maxWidth: '900px', width: '100%', ...moduleBoxStyle }}>
                        <Box sx={moduleHeaderStyle}>
                            <Box sx={moduleHeaderTextStyle}>
                                {salesTabs.length > 0
                                    ? 'SALES MODULE'
                                    : purchaseTabs.length > 0
                                    ? 'PURCHASES MODULE'
                                    : 'OTHERS MODULE'}
                            </Box>
                        </Box>
                        <Box sx={{ p: 4, pt: 0 }}>
                            {renderCards(
                                salesTabs.length > 0
                                    ? salesTabs
                                    : purchaseTabs.length > 0
                                    ? purchaseTabs
                                    : othersTabs,
                                3
                            )}
                        </Box>
                    </Box>
                </Box>
            )}
        </Box>
    );
}